export default __webpack_public_path__ + "static/media/shuttersto-322f76df1e89442.7e1e101b.jpg";